import React, { useState } from 'react';
import { ClickAwayListener } from '@mui/material';
import { Tooltip, Underline } from '../../styles';

interface QuestionTextTooltipProps {
  tooltipComponent: JSX.Element;
  children?: React.ReactNode;
  onClick?: () => unknown;
}

export const QuestionTextTooltip: React.FC<QuestionTextTooltipProps & {
  text?: NonNullable<React.ReactNode>;
}> = ({ tooltipComponent, text, children }) => {
  return (
    <Tooltip arrow={true} title={tooltipComponent}>
      <Underline className="underline">{text || children}</Underline>
    </Tooltip>
  );
};

export const TrueImpactTooltipOnClick: React.FC<QuestionTextTooltipProps & {
  disableHoverListener?: boolean;
  className?: string;
}> = ({
  className,
  tooltipComponent,
  children,
  disableHoverListener = true,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <div onClick={() => setOpen(true)} className={className}>
      <Tooltip
        open={open}
        arrow={true}
        title={tooltipComponent}
        disableHoverListener={disableHoverListener}
      >
        <div>
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <div>{children}</div>
          </ClickAwayListener>
        </div>
      </Tooltip>
    </div>
  );
};

export const TrueImpactTooltip: React.FC<QuestionTextTooltipProps & {
  className?: string;
}> = ({ className, tooltipComponent, children, onClick }) => {
  return (
    <Tooltip arrow={true} title={tooltipComponent}>
      <div className={className} onClick={onClick}>
        {children}
      </div>
    </Tooltip>
  );
};
